<template>
	<div class="ks-videoeditor-inspector">
		<div class="ks-videoeditor-inspector-title">{{ title }}</div>
		<pair-inspector v-if="clip && pair_id" :pair="pair" v-on="$listeners"></pair-inspector>
		<clip-inspector v-else-if="clip" :clip="clip" :crossfades_out="crossfades_out" v-on="$listeners"></clip-inspector>
		<overlay-inspector v-else-if="overlay" :overlay="overlay" v-on="$listeners"></overlay-inspector>
		<audio-inspector v-else-if="audio" :audio="audio" v-on="$listeners"></audio-inspector>
		<div v-else class="ks-videoeditor-empty">Select a clip in the timeline</div>
	</div>
</template>

<script>
import AudioInspector from './AudioInspector.vue'
import ClipInspector from './ClipInspector.vue'
import OverlayInspector from './OverlayInspector.vue'
import PairInspector from './PairInspector.vue'

// Right panel: shows the editor for the selected clip, transition, overlay or audio item.
// The editors' events (update, preset, set-*, start-at-playhead, duplicate-*, remove-*, split, pair-transition) are passed on as they are.
export default {
	components: {AudioInspector, ClipInspector, OverlayInspector, PairInspector},
	props: {
		clip: Object,
		// Second clip picked for a transition between two clips
		pair_id: Number,
		pair: Object,
		crossfades_out: Boolean,
		overlay: Object,
		audio: Object
	},
	computed: {
		title () {
			return this.overlay ? "Image overlay" : this.audio ? "Audio" : this.pair ? "Transition" : "Clip";
		}
	}
}
</script>
